import 'swiper/css';

import { useEffect, useRef, useState } from 'react';
import { Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { scrollTo } from '@namespace/helpers';

import styles from './index.module.css';

const PageScroll = ({
  slides = [],
  slidesUrls = [],
  defaultSlide = 0,
  activeSlideClass = 'active',
  animationDuration = 750
}) => {
  const [currentPanel, setCurrentPanel] = useState(defaultSlide);
  const [overflowHidden, setOverflowHidden] = useState(true);
  const swiperRef = useRef(null);
  const wrapperRef = useRef();
  const [isEnd, setIsEnd] = useState(false);
  const calculatedSliderHeight = 'calc(100vh - var(--header-height))';

  const onReach = (swiper) => {
    if (swiper) {
      setTimeout(() => {
        setIsEnd(swiper.isEnd);
      }, 100); // Timeout is required because isBeginning and isEnd are updated with a delay
    }
  };
  const nextSlide = () => {
    swiperRef.current?.slideNext();
    onReach(swiperRef.current);
  };

  useEffect(() => {
    if (isEnd) {
      setTimeout(() => setOverflowHidden(false), 500);
    } else {
      setOverflowHidden(true);
    }
  }, [isEnd]);

  useEffect(() => {
    scrollTo();
  }, [currentPanel]);

  useEffect(() => {
    if (overflowHidden) {
      document.body.classList.add(styles.overflow);
    } else {
      document.body.classList.remove(styles.overflow);
    }
  }, [overflowHidden]);

  const onInit = (swiper) => {
    onReach(swiper);
    setCurrentPanel(swiper.realIndex);
  };

  const handleSlideChange = (swiper) => {
    onReach(swiper);
    setCurrentPanel(swiper.activeIndex);
  };

  return (
    <div className={styles.wrapper} ref={wrapperRef}>
      <Swiper
        style={{ height: calculatedSliderHeight, width: '100%' }}
        direction="vertical"
        modules={[Mousewheel]}
        mousewheel={{
          releaseOnEdges: true,
          forceToAxis: true
        }}
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          onInit(swiper);
        }}
        speed={animationDuration}
        initialSlide={defaultSlide}
        onSlideChange={handleSlideChange}
        touchReleaseOnEdges={true}
        touchRatio={0.5} // Decreasing swipe sensitivity
      >
        {slides.map((slide, index) => (
          <SwiperSlide
            key={slidesUrls[index] || index}
            className={currentPanel === index ? activeSlideClass : ''}
          >
            {slide}
          </SwiperSlide>
        ))}
      </Swiper>
      {!isEnd && <div className={styles.nextButton} onClick={nextSlide} />}
    </div>
  );
};

export default PageScroll;
